﻿(function () {
    'use strict';

    var app = angular.module('app.config');

    /*--------------------- Config Toast --------------------------*/
    // Configure Toastr
    toastr.options.timeOut = 4000;
    toastr.options.positionClass = 'toast-bottom-right';

    /*--------------------- Config HotKeys --------------------------*/
    var keyCodes = {
        backspace: 8,
        tab: 9,
        enter: 13,
        esc: 27,
        space: 32,
        pageup: 33,
        pagedown: 34,
        end: 35,
        home: 35,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        insert: 45,
        del: 46
    };

    /*--------------------- Config Image --------------------------*/
    var imageSettings = {
        imageBasePath: '../content/images/photos/',
        unknownPersonImageSource: 'unknown_person.jpg'
    };

    /*---------------------  Paths To Server --------------------------*/
    var basePaths = {
        //Trandepot portal resources
        //Base_Path_Resources: 'http://localhost:2559/api/',
        Base_Path_Resources: process.env.Base_Path_Resources,
        //reportes
        //Report_Path_Resources: 'http://localhost:2559/api/ReportProvider',
        Report_Path_Resources: process.env.Report_Path_Resources,
        //Transdepot.Services
        //Service_Path_Resources: 'http://localhost:13167/api/',
        Service_Path_Resources: process.env.Service_Path_Resources,
        //Password Recovery Url
        //Password_Recovery_Path: 'http://contopsa-qa/transdepot.security.web/#/forgotpassword'
        Password_Recovery_Path: process.env.Password_Recovery_Path,
    };

    var envBasePaths = '#{EnvironmentName}';
    if (!envBasePaths.startsWith('#')) {
        Object.assign(basePaths,
            {
                //'http://localhost:2559/transdepot.security.web-beta/#/forgotpassword',
                Password_Recovery_Path: process.env.Password_Recovery_Path,

                //'http://localhost:2559/api/'
                Base_Path_Internal_Services: process.env.Base_Path_Internal_Services
            });
    }

    /*---------------------  Config Spinner --------------------------*/
    var spinnerOptions = {
        radius: 20,
        lines: 11,
        length: 1,
        width: 8,
        speed: 1.7,
        corners: 1.0,
        trail: 100,
        color: '#146794',

    };

    var events = {
        controllerActivateSuccess: 'event:on-spinner-success',
        controllerActivateInit: 'event:on-spinner-init',
        spinnerToggle: 'spinner.toggle',
        controllerToogleSplash: 'event:on-splash-init',
        controllerActivateSplashProgress: 'event:on-splash-init',
    };

    var languages = [
        { code: 'en-US', name: 'Ingles' },
        { code: 'es-ES', name: 'Español' }
    ];


    /*---------------------  Config Constructor --------------------------*/
    var config = {
        appErrorPrefix: '[TransDepotPortalWeb Error] :',
        docTitle: 'TransDepotPortalWeb: ',
        events: events,
        keyCodes: keyCodes,
        imageSettings: imageSettings,
        version: process.env.App_Build_Number,
        environment: process.env.App_Environment,
        basePaths: basePaths,
        cldk: '8080808080808080',//key AES to encript  
        cldv: '8080808080808080',//iv  AES to encript
        cld: 'ngAuthApp',//Client id to Auth2
        useRefreshTokens: false,
        defaultLanguage: 'es-ES',//'en-US',
        spinnerOptions: spinnerOptions,
        organizationCode: 'CON',
        applicationCode: 'TDP',
        grantType: 'password',
        recaptchaSitekey: '#{recaptchaSitekey}',
        get scope() { return this.applicationCode + ' ' + this.organizationCode; },
        languages: languages
    };

    var envConfig = '#{EnvironmentName}';
    
    if (!envConfig.startsWith('#')) {
        Object.assign(config,
        {
            organizationCode: 'CON',
            applicationCode: 'TDP',
            // version: '#{TD.Version}',
            // environment: '#{TD.Environment}'
        });
    }

    app.constant('config', config);

    /*---------------------  Config $log --------------------------*/
    app.config(['$logProvider', function ($logProvider) {
        // turn debugging off/on (no info or warn, only Debug)      
        if ($logProvider.debugEnabled()) {
            $logProvider.debugEnabled(true);
        }
    }]);

     /* ngExDialog Config */
    app.config(['exDialogProvider', function (exDialogProvider) {
        exDialogProvider.setDefaults({
            template: "../assets/lib/ngExDialog/_commonDialog.html",
            draggable: false,
            closeByXButton: false,
            closeByClickOutside: false
        });
    }]);
})();